/**
 * @generated SignedSource<<5d05fde80a180f12395ebeb2fcd2c2cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStakingOverviewQuery$variables = {
  assetId: string;
  endDate: DateScalar;
  startDate: DateScalar;
};
export type AssetStakingOverviewQuery$data = {
  readonly lastMonth: {
    readonly totalRewardsFiat: PrecisionFloat | null | undefined;
  } | null | undefined;
  readonly overview: {
    readonly items: ReadonlyArray<{
      readonly asset: {
        readonly portfolio: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly assets: {
                readonly edges: ReadonlyArray<{
                  readonly fiatTotalStakedAmount: PrecisionFloat | null | undefined;
                  readonly stakedBalance: ValueChange | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
      readonly rewardsAsset: PrecisionFloat;
      readonly rewardsFiat: PrecisionFloat;
      readonly stakedAsset: PrecisionFloat;
      readonly stakedFiat: PrecisionFloat;
    }> | null | undefined;
  } | null | undefined;
};
export type AssetStakingOverviewQuery = {
  response: AssetStakingOverviewQuery$data;
  variables: AssetStakingOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v3 = {
  "items": [
    {
      "kind": "Variable",
      "name": "assetIds.0",
      "variableName": "assetId"
    }
  ],
  "kind": "ListValue",
  "name": "assetIds"
},
v4 = [
  {
    "fields": [
      (v3/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsAsset",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsFiat",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedFiat",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedAsset",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetPortfoliosConnection",
  "kind": "LinkedField",
  "name": "portfolio",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetPortfoliosEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Portfolio",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioAssetsConnection",
              "kind": "LinkedField",
              "name": "assets",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PortfolioAssetsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fiatTotalStakedAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stakedBalance",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": "lastMonth",
  "args": [
    {
      "fields": [
        (v3/*: any*/),
        {
          "kind": "Variable",
          "name": "endDate",
          "variableName": "endDate"
        },
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "concreteType": "StakingOverview",
  "kind": "LinkedField",
  "name": "stakingOverview",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalRewardsFiat",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetStakingOverviewQuery",
    "selections": [
      {
        "alias": "overview",
        "args": (v4/*: any*/),
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v10/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssetStakingOverviewQuery",
    "selections": [
      {
        "alias": "overview",
        "args": (v4/*: any*/),
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v10/*: any*/)
    ]
  },
  "params": {
    "cacheID": "ee8a2ad731dd87f08869264e951dd50d",
    "id": null,
    "metadata": {},
    "name": "AssetStakingOverviewQuery",
    "operationKind": "query",
    "text": "query AssetStakingOverviewQuery(\n  $assetId: ID!\n  $startDate: Date!\n  $endDate: Date!\n) {\n  overview: stakingOverview(input: {assetIds: [$assetId]}) {\n    items {\n      rewardsAsset\n      rewardsFiat\n      stakedFiat\n      stakedAsset\n      asset {\n        __typename\n        portfolio {\n          edges {\n            node {\n              assets {\n                edges {\n                  fiatTotalStakedAmount\n                  stakedBalance\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  lastMonth: stakingOverview(input: {assetIds: [$assetId], startDate: $startDate, endDate: $endDate}) {\n    totalRewardsFiat\n  }\n}\n"
  }
};
})();

(node as any).hash = "114a2a479ddc7cf273667caee654b920";

export default node;
